import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from '../../../../shared/services/lookup.service';
import { LookUp } from '../../../../shared/models/look-up.model';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Attachment } from '../../../../shared/models/attachment.model';
import { AttachmentType, NearestLocation, Service, Languages } from 'src/app/shared/models/enums.model';
import { QualityRequestDTO } from '../../../models/quality-Request-DTO.model';
import { QualityRequestService } from '../../../services/quality-request.service';
import { ActivatedRoute } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { CustomValidators } from '../../../models/custom-validator';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AppConfig } from 'src/app/shared/services/app.config';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-create-hardness-test-request',
  templateUrl: './create-hardness-test-request.component.html',
  styleUrls: ['./create-hardness-test-request.component.css']
})
export class CreateHardnessTestRequestComponent implements OnInit {
  addHardnessTestRequestForm: FormGroup;
  submitted: boolean = false;
  measurementUnits: LookUp[];
  attachments: Attachment[] = [];
  drawingsFileProgress: number;
  showSuccessMessage: boolean;
  showUnsuccessMessage: boolean;
  model: QualityRequestDTO;
  nearestLocation = NearestLocation;
  nearestLocationKeys = Object.keys(this.nearestLocation);
  requestId: any;
  isReadOnly: boolean = false;
  drawingAttachmentUrl;
  displayedLang: string;
  patternPhoneNumber: string = "(^0[0-9]{7,14}$)|(^\u0660[\u0660-\u0669]{7,14}$)";
  showRequest = true;
  responseObj: ResponseObject;
  loading = false;
  isErrorMessage: boolean = false;
  userInfo: any;
  baseRequestDTO: BaseRequest;
  drawingAttachmentExist :string;
  constructor(
    private formBuilder: FormBuilder,
    private lookupService: LookupService,
    private fileService: fileService,
    private qualityRequestService: QualityRequestService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private authSrevice: AuthenticationService
  ) {

    if (history.state.data && history.state.data.requestId)
      this.requestId = history.state.data.requestId;
    //this.requestId = this.route.snapshot.params.Id;
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.model = new QualityRequestDTO();
    this.nearestLocationKeys = this.nearestLocationKeys.slice(this.nearestLocationKeys.length / 2);
    this.buildForm();

  }

  ngOnInit() {
    if (history.state.data && history.state.data.isCompleted) {
      this.isReadOnly = true;
    }else if((!history.state.data )&&this.authSrevice.currentUserValue.IsAdmin){
      window.history.back();
    }
    this.isReadOnly = this.requestId != null ? true : false;

    this.getMeasurementUnitsLookUp();
    if (this.requestId) {
      this.getQualityRequest();
    }
  }

  get f() {
    //console.log(this.registerForm.controls);
    return this.addHardnessTestRequestForm.controls;
  }

  getMeasurementUnitsLookUp() {
    this.lookupService.getMeasurementUnits().subscribe(x => {
      this.measurementUnits = x.Data;
    })

  }

  getQualityRequest() {
    this.qualityRequestService.getQualityRequest(this.requestId).subscribe(
      d => {
        this.model = d.Data;
        this.addHardnessTestRequestForm.patchValue({
          DesiredDate: this.model.DesiredDate!=null?new Date(this.model.DesiredDate):'',
          Description: this.model.Description,
          MaterialType: this.model.MaterialType,
          MeasurementUnitId: this.model.MeasurementUnitId,
          NearestLocation: this.model.NearestLocation,
          MobileNumber: this.model.MobileNumber,
          Fax: this.model.Fax,
          CustomerName: this.model.CustomerName,
          TermsAndConditions: true
        });
        this.baseRequestDTO = this.model.baseRequest;
        this.userInfo = {
          MobileNumber: this.model.MobileNumber,
          Fax: this.model.Fax,
          CustomerName: this.model.CustomerName
        };
        var baseUrl = AppConfig.settings.apiServer.UploadsUrl;
        var shipyardUploadsFolder = AppConfig.settings.apiServer.ShipyardUploadsFolder;
        this.drawingAttachmentUrl = this.model.Attachments.find(x => x.AttachmentType == AttachmentType.HardnessTestRequestDrawings) != undefined ?
          this.model.Attachments.find(x => x.AttachmentType == AttachmentType.HardnessTestRequestDrawings).URL : '';
        this.drawingAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.drawingAttachmentUrl;
        this.drawingAttachmentExist = this.drawingAttachmentUrl.substring(this.drawingAttachmentUrl.lastIndexOf('/')+1);
      }
    );
  }

  public async onFileSelected(event, currFormControl,docName, attachmentType: AttachmentType, progressVariableName, key) {
    this[progressVariableName] = 0;
    this.alertService.clear();
    let localizationKeyValue = await this.translate.get(key).toPromise();
    if (!this.fileService.IsFileExtentionValid(event)) {
      var formControlName = event.target.attributes['formControlName'].value;
      this.addHardnessTestRequestForm.controls[formControlName].setValue("");
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElements && invalidElements.length > 0) {
      //   invalidElements[0].scrollIntoView();
      // }
      return false;
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      var formControlName = event.target.attributes['formControlName'].value;
      this.addHardnessTestRequestForm.controls[formControlName].setValue("");
      var errorMessage = await this.translate.get('FRONT_USER.MaxFileSizeTitle').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElement && invalidElement.length > 0) {
      //   invalidElement[0].scrollIntoView();
      // }

      return false;
    }

    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      formData.append('DocumentName', docName);
      formData.append('FolderName', AppConfig.settings.apiServer.ShipyardUploadsFolder);
      this.fileService.fileUploader(formData).subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            const percentDone = Math.round(100 * event.loaded / event.total)

            this[progressVariableName] = percentDone;
            currFormControl.setErrors({'invalid': true});
          } else if (event instanceof HttpResponse) {

            var jsonResponse = event.body.Data;
            var Url = jsonResponse.Url;
            var attachment = new Attachment();
            attachment.URL = Url;
            attachment.DocumentName = docName;
            attachment.AttachmentTypeId = attachmentType;
            this.model.Attachments = this.model.Attachments.filter(h => h.DocumentName != docName);
            this.model.Attachments.push(attachment);
            currFormControl.setErrors(null);
          }
        }
      );
    }
  }

  buildForm() {
    this.addHardnessTestRequestForm = this.formBuilder.group({
      DesiredDate: ['', [Validators.required, CustomValidators.dateValidator()]],
      Description: ['', [Validators.required, Validators.maxLength(500), CustomValidators.textSpaceValidator()]],
      MaterialType: ['', [Validators.maxLength(50), Validators.required]],
      MeasurementUnitId: [null, [Validators.required]],
      DrawingsFileInput: ['', []],
      TermsAndConditions: [false, [Validators.requiredTrue]],
      NearestLocation: ['', [Validators.required]],
    });
  }

onSubmit() {
    this.submitted = true;
    // stop here if form is invalid

    if (this.addHardnessTestRequestForm.invalid || this.addHardnessTestRequestForm.controls['MeasurementUnitId'].value == 'null') {
      return;
    }
    //this.addHardnessTestRequestForm.controls['MobileNumber'].setValue(this.addHardnessTestRequestForm.controls.MobileNumber.value.internationalNumber);
    //Enable Loader
    this.globalSrv.isLoaderEnabled = true;
    this.model.Description = this.addHardnessTestRequestForm.get("Description").value;
    this.model.DesiredDate = this.addHardnessTestRequestForm.get("DesiredDate").value;
    this.model.MaterialType = this.addHardnessTestRequestForm.get("MaterialType").value;
    this.model.MeasurementUnitId = this.addHardnessTestRequestForm.get("MeasurementUnitId").value;
    this.model.Fax = this.addHardnessTestRequestForm.get("Fax").value;
    // this.model.MobileNumber = this.addHardnessTestRequestForm.get("MobileNumber").value;
    this.model.CustomerName = this.addHardnessTestRequestForm.get("CustomerName").value;
    this.model.NearestLocation = this.addHardnessTestRequestForm.get("NearestLocation").value;
    this.model.ServiceId = Service.HardnessTest;
    this.model.RequestorId = this.authSrevice.currentUserValue.UserId;
    this.model.Drawings = this.attachments.length !== 0 ? this.attachments[0].URL : "";
    this.model.MobileNumber = this.addHardnessTestRequestForm.controls.MobileNumber.value;
    this.qualityRequestService.addQualityRequest(this.model).subscribe(
      (data: ResponseObject) => {
        this.responseObj = data;
        if (this.responseObj.Success) {
          let message: string;
          this.addHardnessTestRequestForm.reset();
          this.showRequest = false;
          this.loading = false;
          //Disable Loader
          this.globalSrv.isLoaderEnabled = false;
          // console.log("Success");
        }
        else {
          this.loading = false;
          this.isErrorMessage = true;
          this.showRequest = false;
          //Disable Loader
          this.globalSrv.isLoaderEnabled = false;
          // console.log("Fail");
        }
      });
  }

  goToTermsAndConditions(): void {
    if (this.globalSrv.getLanguage() == Languages.Arabic)
        window.open(AppConfig.settings.apiServer.ShipyardTermsAR, '_blank');
    else
        window.open(AppConfig.settings.apiServer.ShipyardTermsEN, '_blank');
  }
}
